// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"LunarPatientDownload-module__downloadButton___2tV3x","downloadText":"LunarPatientDownload-module__downloadText___1FaMH"};